import { render, staticRenderFns } from "./NewOrderRedirect.vue?vue&type=template&id=d2a98c54"
import script from "./NewOrderRedirect.vue?vue&type=script&lang=js"
export * from "./NewOrderRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports